// Shared config for all Dental Clinic concept websites, rendered by DentalSite.js.
// Only real, dossier-sourced info is used — no invented prices, staff, or reviews.
export const CLINICS = {
  "21-dental-clinic-concept": {
    name: "21 Dental Clinic",
    doctor: "Dr. Jonathan W. Cunanan",
    tagline: "General Dentistry, Cosmetic Dentistry & Orthodontics",
    theme: "sky",
    heroType: "photo",
    hero: "/dental/21-dental-clinic-concept/hero.jpg",
    logo: "/dental/21-dental-clinic-concept/hero.jpg",
    address: "Room 21, 2/F Twin Arcade Building, Perdices St., Dumaguete City",
    phone: "(035) 421-0046",
    phone2: "0926 949 6058",
    facebook: "https://www.facebook.com/p/21-Dental-Clinic-100064084718508/",
    rating: null,
    fbRecommend: { pct: 100, count: 5 },
    spaces: [
      { img: "/dental/21-dental-clinic-concept/interior.jpg", caption: "Inside the treatment room at 21 Dental Clinic" },
    ],
    care: [
      { img: "/dental/21-dental-clinic-concept/treatment.jpg", caption: "A treatment in progress at 21 Dental Clinic" },
      { img: "/dental/21-dental-clinic-concept/lab-molds.jpg", caption: "Dental impressions prepared in-house at 21 Dental Clinic" },
    ],
    services: ["General Dentistry", "Cosmetic Dentistry", "Orthodontics", "Tooth Extraction"],
    quotes: [],
    mapQuery: "Twin Arcade Building Perdices St Dumaguete City",
  },
  "baroquina-dental-concept": {
    name: "Baroquiña Dental Clinic",
    doctor: "Dr. Sheramil Baroquiña",
    tagline: "Affordable, Approachable Family Dentistry",
    theme: "mint",
    heroType: "promo",
    hero: "/dental/baroquina-dental-concept/hero.png",
    logo: "/dental/baroquina-dental-concept/logo.jpg",
    spaces: [
      { img: "/dental/baroquina-dental-concept/team-storefront.jpg", caption: "Dra. Sheramil Baroquiña and the team outside Baroquiña Dental Clinic" },
    ],
    team: [
      { img: "/dental/baroquina-dental-concept/team.jpg", caption: "The Baroquiña Dental Clinic team" },
    ],
    care: [
      { img: "/dental/baroquina-dental-concept/kids.jpg", caption: "Gentle dental care for kids" },
      { img: "/dental/baroquina-dental-concept/preventive.jpg", caption: "Preventive cleaning and check-ups at Baroquiña Dental Clinic" },
    ],
    address: "Corner Araneta & Rosario St., Bacolod City",
    branches: [
      { name: "Rosario Branch", note: "Corner Araneta & Rosario St., Bacolod City" },
      { name: "Lacson Branch", note: "15th Street, Lacson, Bacolod City" },
    ],
    phone: "+63 961 120 8978",
    phone2: "0969 047 0260",
    facebook: "https://www.facebook.com/baroquinadentalclinic/",
    instagram: "https://www.instagram.com/baroquinadentalclinic/",
    bookingLink: "https://seriousmd.com/doc/sheramil-baroquia",
    rating: { value: "4.8", count: 42 },
    services: ["General Dentistry", "Pediatric Dental Care", "Cosmetic Dentistry", "Tooth Extraction"],
    quotes: [
      { text: "Had a painful impacted tooth. Dr. Luwela made me calm and comfortable — the extraction was unexpectedly smooth and painless. Clean clinic, accommodating staff.", source: "Google review", author: "Beah Artagame" },
      { text: "10/10 experience. Dra. Luwela cared for both me and my children, explained everything clearly and the staff were friendly and accommodating.", source: "Google review", author: "Jessa Pahilanga" },
      { text: "Highly recommended, very affordable while offering high-quality service — the dentist and staff are approachable.", source: "Facebook public testimonial" },
    ],
    mapQuery: "Araneta Rosario St Bacolod City",
  },
  "beyond-smile-dental-concept": {
    name: "Beyond Smile Dental",
    doctor: "Dr. Samira Sadat Rodriguez Tehrani",
    tagline: "Modern Dentistry at Central Arcade",
    theme: "mono",
    heroType: "promo",
    hero: "/dental/beyond-smile-dental-concept/banner.jpg",
    logo: "/dental/beyond-smile-dental-concept/logo.jpg",
    doctorSpotlight: { name: "Dr. Samira Sadat Rodriguez Tehrani", blurb: "Dentist at Beyond Smile Dental, Central Arcade — recommended locally for general and orthodontic care." },
    care: [
      { img: "/dental/beyond-smile-dental-concept/xray.jpg", caption: "A real digital panoramic X-ray used at Beyond Smile Dental" },
      { img: "/dental/beyond-smile-dental-concept/veneer-result.jpg", caption: "A real cosmetic veneer result shared by Beyond Smile Dental" },
    ],
    address: "B6 Central Arcade, JP Teves St., Dumaguete City 6200",
    phone: "+63 917 881 1737",
    email: "beyondsmiledental@gmail.com",
    facebook: "https://www.facebook.com/Dr.SamiraRodriguezTehrani/",
    rating: { value: "5.0", count: 22 },
    services: ["General Dentistry", "Cosmetic Dentistry", "Orthodontics", "Restorations"],
    quotes: [
      { text: "Recommends Beyond Smile Dental at Central Arcade in a local dentist-recommendation thread.", source: "Reddit r/dumaguete", author: "ConsistentAlgae2141" },
      { text: "Recommends trying Beyond Smile for orthodontic care — clinic is inside Central Arcade near the police station.", source: "Reddit r/dumaguete", author: "Opposite_Guess_634" },
    ],
    mapQuery: "Central Arcade JP Teves St Dumaguete City",
  },
  "blacano-dental-concept": {
    name: "Blacano Dental Center",
    doctor: "Dr. Kyra Jean Blacano",
    tagline: "Modern, Well-Equipped Orthodontic Care",
    theme: "gold",
    heroType: "photo",
    hero: "/dental/blacano-dental-concept/doctor.jpg",
    logo: "/dental/blacano-dental-concept/logo.jpg",
    doctorSpotlight: { name: "Dr. Kyra Jean Blacano, Chief Dentist", img: "/dental/blacano-dental-concept/doctor.jpg", blurb: "Patients describe Dr. Kyra as kind, gentle and clear in explaining treatment — praised for orthodontic and TAD (temporary anchorage device) cases, and for following up by SMS after surgery." },
    spaces: [
      { img: "/dental/blacano-dental-concept/intraoral-cam.jpg", caption: "Using an intraoral camera to walk patients through treatment at Blacano Dental Center" },
    ],
    care: [
      { img: "/dental/blacano-dental-concept/ortho.jpg", caption: "Braces with TADs — ongoing overjet correction" },
      { img: "/dental/blacano-dental-concept/aesthetic-restoration.jpg", caption: "Aesthetic restoration case shared by Blacano Dental Center" },
    ],
    address: "Corner Burgos & Magdalo St., La Paz, Iloilo City 5000",
    phone: "+63 981 170 5118",
    phone2: "(033) 330-2879",
    facebook: "https://www.facebook.com/Bdc.ilo/",
    instagram: "https://www.instagram.com/bdciloilo/",
    rating: { value: "5.0", count: 46 },
    fbRecommend: { pct: 100, count: 23 },
    services: ["Orthodontics & Braces", "TAD-Assisted Correction", "General Dentistry", "Cosmetic Dentistry"],
    quotes: [
      { text: "Staff were approachable, welcoming and professional. Dr. Kyra was kind and gentle, explained everything clearly, and I felt very good after my surgery — highly recommended.", source: "Google review", author: "Ma. Laika Calizo" },
      { text: "Another dentist recommended extraction, but Dr. Kyra saved the tooth with a root canal and crown instead — worked out great. Modern, well-equipped, professional, and they even texted afterward to check on me.", source: "Google review", author: "Shaira Kim Llanora" },
      { text: "Friendly staff, Dr. Kyra's patience and skill stood out — procedures were explained thoroughly and treatment was painless and efficient.", source: "Google review", author: "Waltz" },
    ],
    mapQuery: "Burgos Magdalo St La Paz Iloilo City",
  },
  "cf-dental-concept": {
    name: "C & F Dental Care Clinic",
    doctor: "Dr. Chariz T. Asoy (CEO) & Dr. Felix Trinidad Asoy (COO, Oral Surgery)",
    tagline: "Smile Professionals — General & Orthodontic Care",
    theme: "amber",
    heroType: "photo",
    hero: "/dental/cf-dental-concept/signage.jpg",
    logo: "/dental/cf-dental-concept/logo.png",
    team: [
      { img: "/dental/cf-dental-concept/before-after.jpg", caption: "The C & F Dental Care team at work" },
      { img: "/dental/cf-dental-concept/team-collage.jpg", caption: "The C & F Dental Care team" },
    ],
    care: [
      { img: "/dental/cf-dental-concept/myobrace-molds.jpg", caption: "Myobrace orthodontic appliances used at C & F Dental Care" },
    ],
    address: "G/F TLT Building, corner Don Gil Garcia & Don Julio Llorente St., Capitol Site, Cebu City 6000",
    phone: "(032) 234-2233",
    phone2: "0977 238 6355",
    email: "candfdentalcare@gmail.com",
    facebook: "https://www.facebook.com/candfdentalcare/",
    instagram: "https://www.instagram.com/candfdental/",
    rating: { value: "4.7", count: 53 },
    fbRecommend: { pct: 100, count: 205 },
    services: ["Myobrace / Orthodontics", "General Dentistry", "Cosmetic Dentistry", "Oral Surgery"],
    quotes: [
      { text: "I'd had bad extractions elsewhere before. Dr. Felix explained the procedure clearly and this one was unusually fast and painless.", source: "DentalClinics.care", author: "M." },
      { text: "Exceptionally friendly staff. Dr. Felix thoroughly explained my wisdom-tooth extraction and aftercare, and Dr. Cha was skilled during stitch removal.", source: "DentalClinics.care", author: "R." },
      { text: "Thank you Dr. Chariz and staff — her calming manner really helped a nervous patient like me relax. Highly recommend this clinic.", source: "DentalClinics.care", author: "J." },
    ],
    mapQuery: "TLT Building Don Gil Garcia Capitol Site Cebu City",
  },
  "cedro-dental-concept": {
    name: "Cedro Dental Clinic",
    doctor: "Dr. Gerzell Diane Cedro",
    tagline: "Gentle Extractions, Confident Whitening",
    theme: "slate",
    heroType: "photo",
    hero: "/dental/cedro-dental-concept/reception.jpg",
    logo: "/dental/cedro-dental-concept/reception.jpg",
    heroPosition: "center",
    spaces: [
      { img: "/dental/cedro-dental-concept/equipment.jpg", caption: "A treatment room at Cedro Dental Clinic" },
    ],
    care: [
      { img: "/dental/cedro-dental-concept/whitening.jpg", caption: "Professional teeth whitening at Cedro Dental" },
      { img: "/dental/cedro-dental-concept/crowns-before-after.jpg", caption: "Crown work — before and after, shared by Cedro Dental Clinic" },
      { img: "/dental/cedro-dental-concept/infocard.png", caption: "Cedro Dental Clinic" },
    ],
    address: "Torres Building, 61 Burgos Avenue, Brgy. 18, Bacolod City, Negros Occidental",
    phone: "+63 945 764 0411",
    phone2: "0969 150 5038",
    email: "cedrodental@gmail.com",
    hours: "Monday – Sunday, 9am – 5pm",
    facebook: "https://www.facebook.com/cedrodental/",
    instagram: "https://www.instagram.com/cedrodental/",
    bookingLink: "https://mydmdapp.com/c/cedrodental",
    rating: { value: "5.0", count: 107 },
    fbRecommend: { pct: 100, count: 40 },
    services: ["Wisdom Tooth Extraction", "Teeth Whitening", "Braces & Veneers", "Smile Makeovers"],
    quotes: [
      { text: "I liked the atmosphere and Dr. Diane — gentle and light-handed. She explains what will happen and discusses options without pressuring you to agree to treatment right away.", source: "Reddit r/Bacolod", author: "ashenyxia" },
      { text: "Had a wisdom tooth removed — no swelling and no pain, and Dr. Diane's technique was very gentle.", source: "Reddit r/Bacolod", author: "shukakokok" },
      { text: "I'm a patient of Dr. Diane Cedro and strongly recommend her — she explains everything and has a gentle hand.", source: "Reddit r/Bacolod", author: "Glittering-World5739" },
    ],
    mapQuery: "Burgos Avenue Barangay 18 Bacolod City",
  },
  "city-smile-dental-concept": {
    name: "City Smile Dental & Associates",
    tagline: "Braces, Whitening & Precise Modern Care",
    theme: "teal",
    heroType: "logo",
    logo: "/dental/city-smile-dental-concept/logo.jpg",
    care: [
      { img: "/dental/city-smile-dental-concept/blueprint.jpg", caption: "Precision implant planning — \"The Blueprint for your new smile\"" },
      { img: "/dental/city-smile-dental-concept/lab-molds.jpg", caption: "Dental lab work prepared for City Smile Dental patients" },
    ],
    address: "Diego De La Viña Rd., Daro, Dumaguete City, Negros Oriental",
    phone: "+63 917 503 3757",
    facebook: "https://www.facebook.com/p/City-Smile-Dental-61556926867480/",
    instagram: "https://www.instagram.com/citysmiledental_dumaguete/",
    rating: { value: "4.7", count: 49 },
    services: ["Braces / Orthodontics", "Teeth Whitening", "Dental Implants", "General Dentistry"],
    quotes: [
      { text: "Currently getting braces here — pricier than some alternatives but the quality justifies it. Welcoming staff, gentle dentist, and very precise work.", source: "Reddit r/dumaguete", author: "DingoFun4242" },
      { text: "The dentist and assistants made me feel very comfortable, and the clinic was clean.", source: "Reddit r/dumaguete", author: "cedcedced_" },
      { text: "Teeth whitening results were excellent and the process was quick and painless.", source: "Facebook patient post" },
    ],
    mapQuery: "Diego De La Vina Rd Daro Dumaguete City",
  },
  "family-tree-dental-concept": {
    name: "Family Tree Dental Care",
    doctor: "Dr. Trisha Angelique T. Sagun & Dr. Ronald C. Sagun",
    tagline: "Trusted, Affordable Care for the Whole Family",
    since: "2016",
    theme: "forest",
    heroType: "photo",
    hero: "/dental/family-tree-dental-concept/interior.jpg",
    logo: "/dental/family-tree-dental-concept/logo.jpg",
    spaces: [
      { img: "/dental/family-tree-dental-concept/signage.jpg", caption: "Family Tree Dental Care signage — Dr. Trisha Angelique T. Sagun & Dr. Ronald C. Sagun" },
    ],
    team: [
      { img: "/dental/family-tree-dental-concept/team.jpg", caption: "The Family Tree Dental Care team at work" },
    ],
    care: [
      { img: "/dental/family-tree-dental-concept/braces.jpg", caption: "Braces care at Family Tree Dental" },
    ],
    address: "G/F Leq Tak Building, Sta. Catalina St., Dumaguete City 6200",
    phone: "(035) 422-1577",
    phone2: "0906 234 3950",
    facebook: "https://www.facebook.com/FamilyTreeDentalDgte/",
    rating: { value: "4.2", count: 22 },
    services: ["Family & General Dentistry", "Braces / Orthodontics", "Wisdom Tooth Extraction", "Root Canals"],
    quotes: [
      { text: "The doctor is informative and nice, and the clinic is impressively clean.", source: "Reddit r/dumaguete", author: "Reasonable-Neat8738" },
      { text: "Had an impacted wisdom tooth removed — the clinic was very clean, aftercare was clearly explained, and the procedure was fairly straightforward.", source: "Reddit r/dumaguete", author: "Aiaz15" },
      { text: "Recommend Family Tree for orthodontic questions too — they're gentle and explain procedures thoroughly.", source: "Reddit r/dumaguete", author: "MoraM5358" },
      { text: "The ambiance makes dental visits feel less fearful — patients now actually look forward to check-ups.", source: "Facebook group / local visitor post" },
    ],
    mapQuery: "Sta Catalina St Dumaguete City",
  },
  "gallinero-dental-concept": {
    name: "Gallinero Dental Center",
    doctor: "Dr. Jerah Leen Mai V. Gallinero & Dr. Judah V. Gallinero",
    tagline: "Compassionate, Professional Care in Iloilo",
    theme: "sage",
    heroType: "photo",
    hero: "/dental/gallinero-dental-concept/sign-close.jpg",
    spaces: [{ img: "/dental/gallinero-dental-concept/sign.jpg", caption: "Gallinero Dental Center" }],
    doctorSpotlight: { name: "Dr. Jerah Leen Mai V. Gallinero & Dr. Judah V. Gallinero", img: "/dental/gallinero-dental-concept/team-doctor.jpg", imgPosition: "75% center", blurb: "A dedicated dental team praised for welcoming, gentle treatment, cleanliness and genuine patient care." },
    team: [
      { img: "/dental/gallinero-dental-concept/team-staff.jpg", caption: "The Gallinero Dental Center team" },
    ],
    care: [
      { img: "/dental/gallinero-dental-concept/before-after.jpg", caption: "A smile result shared by Gallinero Dental Center" },
    ],
    address: "Iloilo City–Aleosan Rd, Jibao-an, Pavia, Iloilo",
    branches: [
      { name: "Jibao-an, Pavia (Main)", note: "Gallinero 2020 Building, Zone 4, Jibao-an, Pavia, Iloilo" },
      { name: "Second Branch", note: "Maria Luisa Building / PHHC Road area, Iloilo" },
    ],
    phone: "+63 906 336 4854",
    phone2: "0910 638 6254",
    facebook: "https://www.facebook.com/GallineroDentalCenterPH/",
    instagram: "https://www.instagram.com/gallinerodentalcenterph/",
    rating: { value: "4.9", count: 234 },
    services: ["General & Family Dentistry", "Cosmetic Dentistry", "Oral Care & Prevention", "Consultations"],
    quotes: [
      { text: "Excellent experience with Dr. Jerah, Dr. Judah and staff; praises welcome, gentle treatment, cleanliness and oral care.", source: "DentalClinics.care", author: "S." },
      { text: "I always feel comfortable at Gallinero — Dr. Jerah and Dr. Judah are wonderful.", source: "Instagram", author: "Kim Jay Ann Halongong" },
      { text: "Calls Gallinero his trusted dental center in Iloilo and highly recommends the clinic.", source: "Facebook public recommendation", author: "Ilonggo Kuya Hermz" },
      { text: "Says the procedure was painless and quick and describes the clinic as professional and compassionate.", source: "Instagram reel comment", author: "Christian Bernie Tirol" },
    ],
    mapQuery: "Iloilo City Aleosan Road Jibao-an Pavia Iloilo",
  },
  "ong-dental-concept": {
    name: "Ong Dental Clinic",
    doctor: "Dr. Arnold Ong",
    tagline: "Serving Dumaguete Across Two Locations",
    theme: "navy",
    heroType: "logo",
    logo: "/dental/ong-dental-concept/logo.jpg",
    team: [
      { img: "/dental/ong-dental-concept/team.jpg", caption: "Dr. Arnold Ong and the Ong Dental Clinic team" },
    ],
    care: [
      { img: "/dental/ong-dental-concept/lab-crown.jpg", caption: "Dental lab work at Ong Dental Clinic" },
    ],
    address: "Sta. Rosa Street corner Cervantes, Dumaguete City",
    branches: [
      { name: "Main Clinic", note: "Sta. Rosa St. corner Cervantes, Dumaguete City · (035) 522-0288" },
      { name: "Daro Branch", note: "Daro, Dumaguete City · (035) 422-4159" },
    ],
    phone: "(035) 522-0288",
    phone2: "(035) 225-2584",
    facebook: "https://www.facebook.com/OngdentalClinic/",
    facebook2: "https://www.facebook.com/Ongdentalclinicdumaguetecity/",
    rating: null,
    qualitativeReputation: "An established Dumaguete clinic with two locations, listed publicly for years.",
    services: ["General Dentistry", "Restorations", "Tooth Extraction", "Consultations"],
    quotes: [],
    mapQuery: "Dumaguete City dental clinic",
  },
  "orevillos-dental-concept": {
    name: "Orevillo's Dental Clinic",
    tagline: "Serving Dumaguete & Siquijor Since 2008",
    theme: "azure",
    heroType: "logo",
    logo: "/dental/orevillos-dental-concept/logo.jpg",
    spaces: [
      { img: "/dental/orevillos-dental-concept/storefront.jpg", caption: "Orevillo's Dental Clinic storefront at Evermall, Dumaguete City" },
    ],
    address: "Ground Floor, Evermall, Dumaguete City",
    branches: [
      { name: "Evermall Clinic", note: "Ground Floor, Evermall, Dumaguete City" },
      { name: "Siquijor Branch", note: "Publicly referenced Siquijor branch, walk-ins and appointments" },
    ],
    phone: "(035) 422-4272",
    phone2: "0949 881 2024",
    facebook: "https://www.facebook.com/OrevillosDentalClinic/",
    rating: null,
    qualitativeReputation: "Serving Dumaguete and Siquijor since 2008.",
    services: ["General Dentistry", "Cosmetic Dentistry (Veneers & Crowns)", "Tooth Extraction", "Consultations"],
    quotes: [
      { text: "A filling done by the clinic was later praised by a US dentist and avoided a crown.", source: "ClinicFinderPH", author: "Stephen Keierleber" },
    ],
    mapQuery: "Evermall Dumaguete City",
  },
  "smiles-dental-concept": {
    name: "Smiles Dental Care",
    doctor: "Dr. Seeress Mae Rubio",
    tagline: "General Dentistry and Orthodontics",
    since: "2008",
    theme: "taupe",
    heroType: "promo",
    hero: "/dental/smiles-dental-concept/promo.png",
    logo: "/dental/smiles-dental-concept/logo.jpg",
    team: [
      { img: "/dental/smiles-dental-concept/team.jpg", caption: "Meet the team: Dr. Mae Rubio (Director & Dentist), Dr. Seleena Lim (Dentist), Joanna (Manager & Dental Assistant), Lyka (Dental Assistant)" },
      { img: "/dental/smiles-dental-concept/team-group.jpg", caption: "The Smiles Dental Care team" },
    ],
    address: "Door 5, A.T. Locsin Building, Dr. V. Locsin St., Dumaguete City 6200",
    branches: [
      { name: "Smiles Dental Care", note: "Dr. V. Locsin St., Dumaguete City" },
      { name: "Focus Dental", note: "Valencia, Dumaguete (by Smiles Dental Care Group PH)" },
    ],
    phone: "+63 956 521 0042",
    phone2: "(035) 421-2303",
    email: "smilesdentalcare.team@gmail.com",
    hours: "Monday – Saturday, 9am – 5pm",
    facebook: "https://www.facebook.com/p/Smiles-Dental-Care-100063740413252/",
    instagram: "https://www.instagram.com/smiles.dentalcare/",
    rating: { value: "4.8", count: 12 },
    services: ["General Dentistry", "Orthodontics", "Cleaning & Prevention", "Consultations"],
    quotes: [
      { text: "Very satisfied; praises the dentist and assistants as kind and gentle and highly recommends the clinic.", source: "Facebook public recommendation", author: "Angel S. Chong" },
      { text: "Praises Dr. Mae \"Mai\" Rubio for attention to detail, a gentle approach and commitment to patient comfort.", source: "Facebook mentions" },
    ],
    mapQuery: "AT Locsin Building Dr V Locsin St Dumaguete City",
  },
  "st-michaels-dental-concept": {
    name: "St. Michael's Dental Care",
    doctor: "Dr. Jai & Dr. Bernie",
    tagline: "Miles of Smiles, Since 2016",
    theme: "crimson",
    heroType: "logo",
    logo: "/dental/st-michaels-dental-concept/logo.jpg",
    care: [
      { img: "/dental/st-michaels-dental-concept/before-after.jpg", caption: "Tooth restoration case, before and after" },
      { img: "/dental/st-michaels-dental-concept/services-banner.jpg", caption: "Services offered at St. Michael's Dental Care" },
    ],
    address: "1/F EROS Pension, Gen. Luna Ave., Iloilo City Proper",
    branches: [
      { name: "Main Branch", note: "1/F EROS Pension, Gen. Luna Street, Iloilo City · (033) 320-0289 / 0947 777 5588" },
      { name: "Molo Branch", note: "Rm 6 Doña Maria Building, corner San Juan & Avanceña St., Molo, Iloilo City · (033) 351-1127" },
    ],
    phone: "+63 947 777 5588",
    phone2: "0945 885 0700",
    email: "st.michaelsdentalcare@hotmail.com",
    facebook: "https://www.facebook.com/saintmichaelsdentalcare/",
    instagram: "https://www.instagram.com/st.michaelsdentalcare/",
    rating: { value: "4.7", count: 62 },
    whatClinicRating: { value: "4.9", count: 4 },
    services: ["Oral Health Consultation", "Digital X-ray", "Aesthetic Dentistry (Veneers)", "Tooth Restoration", "Orthodontics (Braces)", "Dental Implants", "Root Canal Therapy", "Pediatric Dentistry"],
    quotes: [
      { text: "Personnel were professional and the overall dental experience was very good.", source: "Google review", author: "Dave Ramonette Trimanez" },
      { text: "Staff are extremely accommodating and caring — they even check on you after the appointment.", source: "Google review", author: "Gene" },
      { text: "Staff are very nice, patient and relaxed during treatment — by far the best dental practice.", source: "WhatClinic" },
    ],
    mapQuery: "Gen Luna Ave Iloilo City Proper",
  },
  "tooth-doctors-dental-concept": {
    name: "Tooth Doctors Dental Clinic",
    theme: "rose",
    heroType: "promo",
    hero: "/dental/tooth-doctors-dental-concept/hero.jpg",
    logo: "/dental/tooth-doctors-dental-concept/logo.jpg",
    care: [
      { img: "/dental/tooth-doctors-dental-concept/results.jpg", caption: "A real patient result shared by Tooth Doctors (@toothdoctorsdavao)" },
      { img: "/dental/tooth-doctors-dental-concept/ortho-xray1.jpg", caption: "Orthodontic X-ray comparison shared by Tooth Doctors" },
      { img: "/dental/tooth-doctors-dental-concept/ortho-xray2.jpg", caption: "Orthodontic progress detail shared by Tooth Doctors" },
    ],
    address: "2nd Floor Saito Bldg., McArthur Highway, Matina, Davao City (fronting Mapúa Malayan Colleges Mindanao)",
    phone: "(082) 286-2331",
    phone2: "+63 918 928 8143",
    email: "toothdoctorsdvo@gmail.com",
    facebook: "https://www.facebook.com/toothdoctorsdavao/",
    rating: { value: "4.8", count: 54 },
    services: ["Cosmetic & Aesthetic Dentistry", "Orthodontics", "General Dentistry", "Oral Surgery"],
    quotes: [
      { text: "My partner and I were both treated here — they explain what will be done, the dentists and staff are kind, Messenger replies are fast, and they have their own in-house X-ray so we didn't need to go elsewhere.", source: "Reddit", author: "WillowHefty" },
      { text: "I'd put my own integrity behind Tooth Doctors — strongly recommend them.", source: "Facebook public recommendation", author: "Vee Osico" },
      { text: "Public reel strongly recommends Tooth Doctors and calls it the best.", source: "Instagram public reel", author: "Bella Crawford" },
    ],
    mapQuery: "Saito Building McArthur Highway Matina Davao City",
  },
};

export const CLINIC_LIST = Object.keys(CLINICS).map((slug) => ({ slug, ...CLINICS[slug] }));
